var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['flexible-days', {
    'flexible-days_mobile': _vm.isMobile,
}]},_vm._l((_setup.FLEXIBLE_DAYS),function(days){return _c('button',{key:days,class:['flexible-days__option', {
            'flexible-days__option_active': _setup.checkInDateRange?.daysFlexible === days,
        }],attrs:{"type":"button"},on:{"click":function($event){return _setup.setFlexibleDays(days)}}},[_c(_setup.Typo,{attrs:{"variant":"body-m-400"}},[_vm._v(" ±"+_vm._s(_setup.pluralize(['день', 'дня', 'дня'], days))+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }